<template>
  <div v-for="a in reslutData" :key="a.subId" class="nav-item">
    <div
      :style="{
        paddingLeft: a.children ? a.num * 15 + 'px' : '15px',
        fontWeight: '400',
        fontSize: '14px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        textAlign: 'start',
        position: 'relative',
        width: '100%',
        height: '100%',
        cursor: 'default',
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center',
      }"
      class="a-item"
    >
      <a
        :href="`${'#' + a.subId}`"
        data-bs-toggle="collapse"
        role="button"
        aria-expanded="false"
        :aria-controls="a.subId"
        :data-key="a.name"
        class="text-dark"
        @click="changeType(a)"
      >
        <i style="margin-left: 20px"></i>
        <i
          :class="[
            'fs-12',
            a.iconType ? ' bx bxs-down-arrow' : 'bx bxs-right-arrow',
          ]"
          style="color: #fff; position: absolute; top: 3px; left: 5px"
        ></i>
      </a>
      <div
        style="
          display: inline-block;
          width: 90%;
          display: flex;
          align-items: center;
          align-content: center;
        "
      >
        <span>{{ a.name }}</span>
      </div>
    </div>
    <div :class="['collapse', 'show']" :id="a.subId">
      <div
        :style="{
          paddingLeft: a.children ? a.num * 30 + 10 + 'px' : '25px',
          cursor: 'default',
          display: 'flex',
          alignItems: 'center',
          alignContent: 'center',
        }"
        v-for="b in a.attributes && a.attributes.measurements"
        :key="b.name"
        class="a-item"
      >
        <div
          @click="
            () => {
              if (chartIndex.length == 6 && !b.is_checked) {
                $message.error($t('图表最多展示6个测点'));
              }
            }
          "
        >
          <input
            class="form-check-input me-1 mt-0 p-0"
            type="checkbox"
            :checked="b.is_checked"
            @change="singleChecked(b, a)"
            :disabled="chartIndex.length == 6 && !b.is_checked"
          />
        </div>
        <img
          src="../assets/images/value-white.svg"
          style="width: 20px; height: 16px"
          alt=""
        />
        {{ b.name }}&emsp;
        <!-- 空星 
          
          @click="()=>{$message.error('最多置顶展示两个测点')}"-->
        <!-- <i
          v-if="!b.isShow"
          class="ri-star-line cursor-pointer fs-15"
          @click="changeStar(b, a.attributes.measurements)"
        ></i> -->
        <!-- 实星 -->
        <i
          :class="
            b.isShow
              ? ['ri-star-fill', 'cursor-pointer', 'text-warning fs-15']
              : ['ri-star-line', 'cursor-pointer', 'fs-15']
          "
          @click="changeStar(b, a.attributes.measurements)"
        ></i>
      </div>
      <cockpitTreeStar :dataList="a.children"></cockpitTreeStar>
    </div>
  </div>
</template>

<script>
import cockpitTreeStar from "./cockpitTreeStar.vue";
// import { Container, Draggable } from "vue3-smooth-dnd";
import _ from "loadsh";
export default {
  props: ["dataList", "topIndex", "chartIndex"],
  name: "CockpitTree",
  emits: ["saveInstancesSetting", "changeStarStat"],
  components: {
    cockpitTreeStar,
  },
  data() {
    return {
      itemSelecteds: "",
      warnStatusList: ["health", "sub-health", "error", "unknown"],
      reslutData: [],
    };
  },
  watch: {
    topIndex: {
      handler(val) {
        /* 控制星星的显隐 */
        // if(this.isPaperMaking){
          
        this.reslutData = _.cloneDeep(this.dataList);
          this.reslutData.forEach((i) => {
            if (i.attributes && i.attributes.measurements) {
              i.attributes.measurements.forEach((item, index) => {
                if(val.length){
                  // 先将 isShow 设置为默认值 false
                  item.isShow = false;
                  
                  // 遍历 val，只要有一个匹配项就将 isShow 设置为 true
                  val.forEach(top=>{
                    if(item.equipment_id_key == top.equipment_id_key){
                      item.isShow = true;
                    }
                  })
                }

                if (this.chartIndex.includes(item.equipment_id_key)) {
                  item.is_checked = true;
                } else {
                  item.is_checked = false;
                }
              });
            }
          });
        // }
        
      },deep: true,
    },
    dataList: {
      handler(val) {
        /* 控制星星的显隐 */
        this.reslutData = _.cloneDeep(val);
        this.reslutData.forEach((i) => {
          if (i.attributes && i.attributes.measurements) {
            i.attributes.measurements.forEach((item) => {
              this.topIndex.map((top) => {
                if(this.isPaperMaking){
                    if(item.equipment_id_key == top.equipment_id_key){
                      item.isShow = true
                    }else{
                      item.isShow = false;
                    }
                }else{
                  if (top.id == item.id) {
                    //默认展示电流，电压
                    item.isShow = true;
                  }else{
                    item.isShow = false;
                  }
                }
              });
              if (this.chartIndex.includes(item.equipment_id_key)) {
                item.is_checked = true;
              } else {
                item.is_checked = false;
              }
            });
          }
        }); 
             
      },immediate:true,
    },
  },
  computed:{
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.isDemonstrationPaperMaking;
    }
  },
  methods: {
    changeType(item) {
      item["iconType"] = !item["iconType"];
    },
    selectedsDetail(item, aItem) {
      this.$emit("getDetailId", item, aItem);
    },
    singleChecked(item, aItem) {
      let list = aItem.attributes.measurements,
        indexs = [],
        index_id = [];
      item.is_checked = !item.is_checked;
      list.forEach((it_, i) => {
        // if(item.key == it_.key){
        //   it_.is_checked = !it_.is_checked
        // }
        /* 遍历出投选状态下测点索引数组 */
        if (!it_.is_checked) {
          indexs.push(it_.equipment_id_key);
        } else {
          index_id.push(it_.equipment_id_key);
        }
      });
      this.$emit("saveInstancesSetting", { indexs, index_id });
    },
    // 改变展示状态
    changeStar(item) {
      let result = [];
      item.isShow = !item.isShow;
      this.reslutData.forEach((i) => {
        if (i.attributes && i.attributes.measurements) {
          i.attributes.measurements.forEach((items) => {
            if (items.isShow) {
              result.push(items);
            }
          });
        }
      });
      if (result.length > 2) {
      item.isShow = !item.isShow;
        this.$message.error(this.$t("最多置顶展示两个测点"));
      } else {
        // 置顶状态传递

        this.$emit("changeStarStat", result);
      }
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.form-check-input {
  background: #000;
}
.form-check-input:checked {
  background: #0ed1d5;
  border-color: #0ed1d5;
}
.a-item {
  padding-top: 5px;
  padding-bottom: 5px;
}
.a-item:hover {
  background: #212b33;
  cursor: default;
}
</style>
